import styled from 'styled-components';

export const KitFlexCentered = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  * {
    box-sizing: border-box;
  }
`;

export const KitFlexCol = styled.div`
  display: flex;
  flex-direction: column;
  * {
    box-sizing: border-box;
  }
`;

export const KitFlexRow = styled.div`
  display: flex;
  flex-direction: row;
  * {
    box-sizing: border-box;
  }
`;

export const KitFlexColSpaced = styled(KitFlexCol)`
  justify-content: space-between;
`;

export const KitFlexRowSpaced = styled(KitFlexRow)`
  justify-content: space-between;
`;

export const KitFlexColCentered = styled(KitFlexCol)`
  justify-content: center;
`;

export const KitFlexRowCentered = styled(KitFlexRow)`
  justify-content: center;
`;

export const KitFlexColEnd = styled(KitFlexCol)`
  justify-content: flex-end;
`;

export const KitFlexRowEnd = styled(KitFlexRow)`
  justify-content: flex-end;
`;

export const KitFlexWrapRow = styled(KitFlexRow)`
  flex-flow: wrap;
`;

export const KitFlexWrapRowEnd = styled(KitFlexWrapRow)`
  justify-content: flex-end;
`;

export const KitFlexWrapRowSpaced = styled(KitFlexWrapRow)`
  justify-content: space-between;
`;

export const KitFlexWrapRowCentered = styled(KitFlexWrapRow)`
  justify-content: center;
`;
